var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesign = function SvgDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.08 12.422 4.695 4.647a3.23 3.23 0 0 0 4.537 0l6.146-6.083 2.986-1.477a1 1 0 0 0 .26-1.607L12.66.931a3.23 3.23 0 0 0-4.537 0L1.079 7.902a3.17 3.17 0 0 0 0 4.52m10.173-10.07 6.048 5.986-1.665.824H2.649l6.88-6.81a1.23 1.23 0 0 1 1.724 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.166 12.813-.18-.19-.181.19-.002.002-.005.005-.018.019-.066.072q-.086.095-.232.266c-.191.227-.447.547-.703.92-.502.735-1.044 1.728-1.044 2.638 0 .88.268 1.515.703 1.928.433.41 1 .572 1.547.572s1.115-.162 1.547-.572c.436-.413.703-1.047.703-1.928 0-.91-.54-1.903-1.043-2.637a12 12 0 0 0-1.001-1.259l-.018-.02-.005-.004z"
  })));
};
export default SvgDesign;